// Encrypt the username (Base64 encoding)
export const encryptUsername = (username) => {
  try {
    if (!username || typeof username !== "string") {
      throw new Error("Invalid input: username must be a non-empty string.");
    }

    const base64Encoded = window.btoa(username); // Encode the username in Base64
    console.log("Base64-encoded username:", base64Encoded);
    return base64Encoded;
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

// Decrypt the username (Base64 decoding)
export const decryptUsername = (encryptedUsername) => {
  try {
    if (!encryptedUsername || typeof encryptedUsername !== "string") {
      throw new Error(
        "Invalid input: encryptedUsername must be a non-empty string."
      );
    }

    console.log("Decrypting username:", encryptedUsername);
    const decodedUsername = window.atob(encryptedUsername); // Decode the Base64 string
    console.log("Decoded username:", decodedUsername);
    return decodedUsername;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

// Store the encrypted username in localStorage
export const storeUsername = (username) => {
  console.log("storeUsername called");

  //   const existingEncryptedUsername = localStorage.getItem("userName");
  //   if (existingEncryptedUsername) {
  //     console.log(
  //       "Username already exists in localStorage. Skipping encryption.",
  //       existingEncryptedUsername
  //     );
  //     return;
  //   }

  const encryptedUsername = encryptUsername(username);
  console.log("Encrypted username:", encryptedUsername);

  if (encryptedUsername) {
    localStorage.setItem("userName", encryptedUsername);
    console.log("Username stored in localStorage:", encryptedUsername);
  } else {
    console.error("Failed to store username: encryption returned null.");
  }
};

// Retrieve and decrypt the username from localStorage
export const getUsername = () => {
  console.log("getUsername called");

  const encryptedUsername = localStorage.getItem("userName");
  console.log(
    "Retrieved encrypted username from localStorage:",
    encryptedUsername
  );

  if (encryptedUsername) {
    return decryptUsername(encryptedUsername);
  }
  console.error("No username found in localStorage.");
  return null;
};
